import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
@Injectable()
export class AuthService implements CanActivate {
  private _accessToken = '';

  constructor(private router: Router) {}

  get accessToken(): string {
    return this._accessToken;
  }

  set accessToken(value: string) {
    this._accessToken = value;
  }
  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (route.queryParams.applicationId && route.queryParams.token) {
      this.accessToken = route.queryParams.token;
    }

    if (route.url[0].path === 'basic-info' || route.url[0].path === 'big-ticket') {
      return true;
    }
    if (this.accessToken === '') {
      // Default routes for big ticket flow
      if (route.url[0].path === 'big-purpose' || route.url[0].path === 'personal-contact') {
        this.router.navigate(['big-ticket']);
        return false;
      }
      this.router.navigate(['basic-info']);
      return false;
    }
    return true;
  }
}
